import Icon from "@mui/material/Icon";
import { styled } from "@mui/material/styles";
import { MDSnackbarIconRootProps } from "./types";

interface StyledIconProps {
  ownerState: MDSnackbarIconRootProps;
}

export default styled(Icon)<StyledIconProps>(({ theme, ownerState }) => {
  const { palette, typography } = theme;
  const { color, bgWhite } = ownerState;

  // Helper function to convert px to rem (simplified)
  const pxToRem = (px: number) => `${px / 16}rem`;

  // Helper function for linear gradient (simplified)
  const linearGradient = (start: string, end: string) => 
    `linear-gradient(195deg, ${start}, ${end})`;

  // Basic colors - fallback to standard Material-UI colors if custom theme not available
  const white = palette.common?.white || '#ffffff';
  const transparent = 'transparent';
  
  // Basic gradients - simplified versions
  const gradients = {
    info: { main: '#1976d2', state: '#42a5f5' },
    success: { main: '#388e3c', state: '#66bb6a' },
    warning: { main: '#f57c00', state: '#ffb74d' },
    error: { main: '#d32f2f', state: '#ef5350' },
    primary: { main: palette.primary.main, state: palette.primary.light },
    secondary: { main: palette.secondary.main, state: palette.secondary.light },
    dark: { main: '#424242', state: '#616161' },
  };

  // backgroundImage value
  let backgroundImageValue;

  if (bgWhite) {
    const gradientColor = gradients[color as keyof typeof gradients] || gradients.info;
    backgroundImageValue = linearGradient(gradientColor.main, gradientColor.state);
  } else if (color === "light") {
    backgroundImageValue = linearGradient(gradients.dark.main, gradients.dark.state);
  }

  return {
    backgroundImage: backgroundImageValue,
    WebkitTextFillColor: bgWhite || color === "light" ? transparent : white,
    WebkitBackgroundClip: "text",
    marginRight: pxToRem(8),
    fontSize: typography.fontSize ? `${typography.fontSize * 1.125}px` : '18px',
    transform: `translateY(${pxToRem(-2)})`,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'auto',
    height: 'auto',
  };
});